secondaryNav = document.querySelector( 'main nav' );

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${window.Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product&resources[limit]=4`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.classList.add('block');
    
    if ( secondaryNav ) {
      secondaryNav.style.marginTop = `${this.predictiveSearchResults.clientHeight + 52 + 4}px`;
    }
  }
  
  close() {
    this.predictiveSearchResults.classList.remove('block');
    
    if ( secondaryNav ) {
      secondaryNav.style.marginTop = '';
      secondaryNav.classList.toggle( 'searchbar-offset' );
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);